
import { t } from 'i18next/dist/commonjs';
import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import { translate } from "react-i18next";
import { getDateDisplayValue } from '../../backend/UIUtils';

class NotifyView extends Component {

    constructor(props) {
        super(props);
        
    }

   
   
    render() {
        const { t } = this.props;
        var full_options = { weekday: 'short', day: 'numeric', month: 'short', year: '2-digit' , hour:'numeric', minute:'numeric'};
        return (<div>
           <Alert key={this.props.entity.notifyId} variant={'warning'}>
           <Alert.Heading>{t("notifyInfo")}</Alert.Heading>
             {getDateDisplayValue(this.props.entity.notifyCreationDate, full_options)} &nbsp;User:&nbsp;{this.props.entity.notifyUserId}
             <br />
             {this.props.entity.comment}
             
          </Alert>        
          </div>)

    }
}

export default translate("translations")(NotifyView);